import { SystemUsersUIProvider } from "./SystemUsersUIContext";
import { SystemUsersCard } from "./SystemUsersCard";

export function SystemUsersPage({ history }) {
  const systemUsersUIEvents = {
    openNewSystemUserPage: () => {
      history.push("/kullanicilar/ekle");
    },
    openEditSystemUserPage: (id) => {
      history.push(`/kullanicilar/duzenle/${id}`);
    },
  };
  
  return (
    <SystemUsersUIProvider systemUsersUIEvents={systemUsersUIEvents}>
      <SystemUsersCard />
    </SystemUsersUIProvider>
 );
}